export const searchUtils = (() => {
    let timeoutId;

    return (textSearch, setSearchAndFilter, column, searchText, objFilter) => {
    const getSearchText = (textSearch, column) => {
      objFilter[column.field] = textSearch;
      if (!textSearch) {
        delete objFilter[column.field];
      }
  
      const searchColumn = Object.keys(objFilter);
      const searchTextValue = Object.values(objFilter);
      const objTextFind = !searchColumn.length ? "" : `&filterBy=${searchColumn.join("|")}&filterValue=${searchTextValue.join("|")}`;
  
      return objTextFind;
    };
  
    const dateRangeRegex = /range=createdAt\|([^|]+)\|([^|]+)/;
    const matches = searchText && searchText.match(dateRangeRegex);
    const objTextFind = getSearchText(textSearch, column);

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
        setSearchAndFilter(matches ? `${objTextFind}&${matches[0]}` : objTextFind, objTextFind);
    }, 2000);
};
})();